import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";

import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import DatePicker from "react-datepicker";
import {Link} from "react-router-dom";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var todayDate = new Date();
var timestamp  = new Date().getTime();
var minDate = new Date('2020-02-01');
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(yesterday).format('MM/DD/YYYY');
var start_date_limit = moment(minDate).format('MM/DD/YYYY');


Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}
class SappireFoodList extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            dateFromLimit: start_date_limit,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[],
            chainList:[],
            merchantID:'ISAP0339',
            chainID:'',
            storeID:'',
            merchantValue:{value: 'ISAP0339', label: 'Sapphire Foods India Pvt Ltd'},
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            txnLists:[{value:'Leg1 QR Transaction', label: 'Leg1'},{value:'Leg2 QR Transaction', label: 'Leg2'}],
            txnValue:'',
            txnIds:'',
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            txnTypeLists: [{value: 'all', label: 'All'}, {value: 'SALE', label: 'SALE'}, {
                value: 'VOID',
                label: 'VOID'
            }, {
                value: 'REVERSAL',
                label: 'REVERSAL'
            },{
                value: 'FAILED',
                label: 'FAILED'
            }],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            isSettledLists: [{value: 'Settled', label: 'Settled'}, {value: 'Unsettled', label: 'Unsettled'}],
            isSettledIDs: '',
            isSettledValue: null,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            listOpen: false,
            headerTitle: "Select [Utid]",

            startDate: yestSend,
            SappireList:[]
        }
        this.close = this.close.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
    }
    componentDidUpdate() {
        const { listOpen } = this.state;
        setTimeout(() => {
            if (listOpen) {
                window.addEventListener('click', this.close);
            } else {
                window.removeEventListener('click', this.close);
            }
        }, 0);
    }
    close() {
        this.setState({
            listOpen: false,
        });
    }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        this._getAllMerchants();

        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.getChain('ISAP0339', 'merchant', 'Merchant', 'ISAP0339');
            this.getStore('ISAP0339', 'merchant', 'Merchant', 'ISAP0339');

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            this.ci_utid('ISAP0339','','',false,'');
        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode);
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);

            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode);
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);

            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData);

            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }

        else {
            this.unauthorize_access();
        }


        if ($.fn.DataTable.isDataTable('#sapphireDashboard')) {
            $('#sapphireDashboard').DataTable().destroy();
        }
        var SetRecord={
            id:''
        }
        axios.post(config.get('API_URL')+'/reportdashboard/sapphire-foods-dashboard',SetRecord,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {

            this.setState({
                SappireList:response.data.data,

            });
           enabledBody();

        });
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        // if(subMenuPermissions.includes("transaction_reports")===false|| reportPermissions.includes("phonePe_transaction")===false){
        //     this.unauthorize_access();
        // }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }




    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                mList.push({value: 'ISAP0339', label: 'Sapphire Foods India Pvt Ltd'})

                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }

        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        var is_enable = compareValues(midArray, this.state.active_mids);
        this.setState({
            // merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable
        });
        // this.get_filtered_phonepe_transaction_report(midArray, '', '', this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.txnIds, this.state.txnTypeIDs, '', this.state.isSettledIDs);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        }
        this.ci_utid(midArray, '','',false,'');

    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                    this.state.chainList.move(index,0).join(',');
                }
            });
        }
        var is_enable = compareValues(cidArray, this.state.active_cids);
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable
        });
        // this.get_filtered_phonepe_transaction_report(this.state.merchantID, cidArray, '', this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.txnIds, this.state.txnTypeIDs, '', this.state.isSettledIDs);

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
        }
        this.ci_utid(this.state.merchantID, cidArray, '',false,'');
    }
    getChain(code, type, object_type, object_code){
        this.setState({
            chainList:[],
            is_chain_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                is_chain_loading: false
            })
        });
    }
    getStore(code, type, object_type, object_code) {
        this.setState({
            storeList:[],
            is_store_loading: false
        })
        axios.post(config.get('API_URL')+'/reports/get-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }

    changeStore(login_type, optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                if (login_type != 'store') {
                    var index = this.state.storeList.findIndex(obj => obj.value==sids.value);
                    this.state.storeList.move(index,0).join(',');
                }
            });
        }
        var is_enable = compareValues(sidArray, this.state.active_sids);
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected,
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable
        });
        // this.get_filtered_phonepe_transaction_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.txnIds, this.state.txnTypeIDs, '', this.state.isSettledIDs);
        this.ci_utid(this.state.merchantID, this.state.chainID, sidArray,false,'');
    }

    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY'),

        });
        if(event.type=='apply'){
            var is_date_change = false;
            if(this.state.active_yestSend==this.state.yestSend && this.state.active_todSend==this.state.todSend){
                is_date_change = false;
            } else {
                is_date_change = true;
            }
            this.setState({
                isChange: is_date_change
            })

        }

    }

    ci_utid(mid,cid,sid,is_search, search_value) {
        let utidList = [];
        let selected_val = '';
        if(is_search===true){
            selected_val = this.state.ciutidIds
        }
        this.setState({
            ciutidList: [],
            is_utid_loading: true
        })
        axios.post(config.get('API_URL') + '/reports/get-utid/', {

                mid: mid,
                cid: cid,
                sid: sid,
                is_search:is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {

            if (Array.isArray(response.data) && response.data.length) {
                response.data.map((ci_utid, index) => {
                    utidList.push(ci_utid.utid)
                });
                if (Array.isArray(this.state.ciutidIds) && this.state.ciutidIds) {
                    utidList = utidList.filter( ( el ) => !this.state.ciutidIds.includes( el ) );
                    this.state.ciutidIds.map((ut,index) => {
                        utidList = [ut, ...utidList.filter(item => item !== ut)];
                    })

                }
                this.setState({
                    ciutidList: utidList,
                    is_utid_loading: false
                })

            } else {

                this.setState({
                    ciutidList: [],
                    is_utid_loading: false
                })
            }

        });
    }

    filterList(e){

        var value = e.target.value
        setTimeout(function() {
            this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, true, value);
        }.bind(this), 200);
    }
    toggleList() {
        this.setState({
            listOpen: !this.state.listOpen,
        });
    }

    changeUtid(utid,checked_item, e){
        let item_list = this.state.ciutidIds
        let checked_list = utid;
        //console.log(checked_list);
        if(checked_item===false) {
            const newData = [utid, ...this.state.ciutidList.filter(item => item !== utid)];
            this.setState({
                ciutidIds: [...this.state.ciutidIds,  utid],
                isChange: true,
                ciutidList: newData
            });

        } else{
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                if(item_list.length<1) {
                    item_list='';
                }
                this.setState({
                    ciutidIds: item_list,
                    isChange: true
                })
            }
        }


        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }

    downloadFile(e){

        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }



    handleFromChange = date => { //alert(date);

        var date_filter = moment(date).format('YYYY-MM-DD');
        this.setState({
            startDate: date_filter
        });

    };

    reset_all(e){
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantID:'ISAP0339',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            tenderModeValue:[],
            is_fallback: 0,
            traCurrencyValue:[],
            traCurrencyIDs:'',
            issuHomeCurrValue:[],
            issuHomeCurrIDs:'',
            campaignCodeValue:[],
            campaignCodeIDs:'',
            txnIds:'',
            txnValue:[],
        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }

   async handleDownload(srNo,Name,extn){
       this.setState({
           is_download: false,
           model_visible: true,
           file_url: '',
           rfile: ''
       });
        var postData={
            sr_no:srNo,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            merchant_code: this.state.merchantID,
            chain_code:this.state.chainID,
            store_code:this.state.storeID,
            utid:this.state.ciutidIds
        }

       var timestamp  = new Date().getTime();
       var BlobType='';
       let fileName = '';
       
            BlobType="octet/stream";
            fileName = timestamp+Name+'.csv.gz';
        


       let xhrBank = await $.ajax({
           url:config.get('API_URL')+ "/reportdashboard/sapphire-foods-dashboard-download",
           type: "POST",
           data: postData,
           beforeSend: function (request) {
               request.setRequestHeader("Authorization", localStorage.usertoken);
           },
           xhrFields: {
               responseType: 'blob'
           },
           success: function (response, status, xhr) {
               let blob = new Blob([response], {
                   type: BlobType
               });


               let rfile = fileName.replace(/\"/g, "");
               //console.log(fileName)
               //let a = document.createElement('a');
               let url = window.URL.createObjectURL(blob);
               // a.href = url;
               // a.download = rfile;
               // a.click();
               // window.URL.revokeObjectURL(url);
               this.setState({
                   is_download: true,
                   file_url: url,
                   rfile: rfile
               })
           }.bind(this)
       });
       this.setState({
           xhrBank: xhrBank
       })


}


    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        const utid_lists = this.state.ciutidList.map((utid_object, index) => {
            var chk_input = <input type='checkbox' checked={false}/>
            var activeCls = 'dd-list-item';
            var checked_item = false;
            if(this.state.ciutidIds.includes(utid_object) === true){
                chk_input = <input type='checkbox' checked={true}/>
                activeCls = "dd-list-item dd-list-active";
                checked_item = true;
            }
            return (
                <li key={index} className={activeCls} onClick={this.changeUtid.bind(this, utid_object,checked_item)}>
                    {chk_input}
                    &nbsp;&nbsp;{utid_object}
                </li>
            )
        })

        const SappData=this.state.SappireList.map(data=>{
            return(
                <tr>
                    <td>{data.sr_no}</td>
                    <td>{data.report_name}</td>
                    <td>{data.description}</td>
                    <td>{data.last_update_time}</td>

                    <td>
                        <Link name={data.sr_no} className="viewButton" data-tip={'Download ' +data.action} to="#"
                              onClick={this.handleDownload.bind(this, data.sr_no, data.report_name,data.action)}> <i className="fa fa-download"></i>
                            {'Download '+data.action}</Link>
                    </td>

                </tr>
            );
        })
        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Sapphire Foods Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-10">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                {/*<DatePicker*/}
                                                {/*    dateFormat="dd-MM-yyyy"*/}
                                                {/*    selected={Date.parse(this.state.startDate)}*/}
                                                {/*    onChange={this.handleFromChange}*/}
                                                {/*    minDate={yesterday}*/}
                                                {/*    maxDate={yesterday}*/}
                                                {/*/>*/}

                                                <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                                 onEvent={this.handleEvent.bind(this)}
                                                                 maxDate={this.state.dateLimit}
                                                                 minDate={this.state.dateFromLimit}
                                                >
                                                    <i className="fa fa-calendar" aria-hidden="true"></i>
                                                    <input type="text" name="dateRange" className="form-control dateRangeInput"
                                                           value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                                </DateRangePicker>
                                            </div>
                                            {this.state.merchant_list_box ===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <ReactMultiSelectCheckboxes name="merchants"
                                                                                isMulti
                                                                                isLoading={this.state.is_merchant_loading}
                                                                                components={{ MenuList }}
                                                                                value={this.state.merchantValue}
                                                                                styles={customStyles} className="report-listbox"
                                                                                isClearable={false}
                                                                                onChange={this.changeMerchant.bind(this,'')}
                                                                                options={this.state.merchantList}
                                                                                placeholderButtonLabel="Select [Merchant]"
                                                    />

                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.chain_list_box===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ReactMultiSelectCheckboxes name="chain"
                                                                                isMulti
                                                                                isLoading={this.state.is_chain_loading}
                                                                                components={{ MenuList }}
                                                                                value={this.state.chainValue}
                                                                                styles={customStyles} className="report-listbox"
                                                                                isClearable={false}
                                                                                onChange={this.changeChain.bind(this,'')}
                                                                                options={this.state.chainList}
                                                                                placeholderButtonLabel="Select [Chain]"
                                                    />
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.store_list_box===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Store </label>
                                                    <ReactMultiSelectCheckboxes name="store"
                                                                                isMulti
                                                                                isLoading={this.state.is_store_loading}
                                                                                components={{ MenuList }}
                                                                                value={this.state.storeValue}
                                                                                styles={customStyles} className="report-listbox"
                                                                                isClearable={false}
                                                                                onChange={this.changeStore.bind(this, '')}
                                                                                options={this.state.storeList}
                                                                                placeholderButtonLabel="Select [Store]"
                                                    />
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <div className="dd-wrapper">
                                                    <div className="dd-header" onClick={() => this.toggleList()}>
                                                        {this.state.ciutidIds==''?
                                                            <div className="dd-header-title">{this.state.headerTitle}</div>:
                                                            <div className="dd-header-title">{this.state.ciutidIds.length} Selected</div>
                                                        }

                                                        <i className="fa fa-angle-down"></i>
                                                    </div>
                                                    {this.state.listOpen ===true?
                                                        <div
                                                            role="list"
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <input
                                                                className="dd-list-search-bar"
                                                                placeholder="Search"
                                                                onChange={(e) => this.filterList(e)}
                                                            />
                                                            <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                            {/*<div className="dd-scroll-list">*/}
                                                            <ul className="dd-list">
                                                                {this.state.is_utid_loading===true?
                                                                    <li>
                                                                        <BeatLoader
                                                                            css={override}
                                                                            sizeUnit={"px"}
                                                                            size={5}
                                                                            color={'#666666'}
                                                                            loading={this.state.is_utid_loading}
                                                                        />
                                                                    </li>: null}
                                                                {utid_lists}

                                                            </ul> </div>: null }
                                                    {/*</div>*/}
                                                </div>
                                                <div className="clearfix"></div>
                                            </div>


                                        </div>

                                    </div>
                                    {/*<div className="row" style={{display:none}}>*/}
                                    {/*    <div className="col-md-5 pull-right">*/}
                                    {/*        {this.state.isChange===true?*/}
                                    {/*            <span className="apply-notification">Please click on Apply button</span>:null*/}
                                    {/*        }*/}
                                    {/*        <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_phonepe_transaction_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>*/}
                                    {/*        &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        {/*<a href="#" className="exportButton" role="button" onClick={this.transactionReportDownload.bind(this)}>*/}
                                        {/*    <i className="fa fa-download" aria-hidden="true"></i>*/}
                                        {/*    Export to CSV*/}
                                        {/*</a>*/}
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="sapphireDashboard" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>S.No.</th>
                                                <th>Report Name</th>
                                                <th>Description</th>
                                                <th>Last Update Time</th>
                                                <th>Action</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {SappData}
                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)( SappireFoodList );